import React, {Component} from "react";

import {isEmpty} from 'lodash';

import {Banner, Header as MyHeader} from "../../components";

import {App, Categories, Events, KnowCity, Posts, Statistics} from "./components";

import {getCity} from "../../redux/actions";
import {APP} from "../../constants";
import {Button, Image, Responsive} from "semantic-ui-react";
import moment from "moment";
import {FormattedMessage} from "react-intl";
import {Products} from "./components/Products";

const subdomain = window.location.host.split('.')[0];
const city = JSON.parse(localStorage.getItem('_CITY'));

const getWidth = () => {
    const isSSR = typeof window === 'undefined';

    return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
};

class Home extends Component {

    constructor(props) {
        super(props);

        this.state = {
            banners: [],
            details: {
                know_title: '',
                about_title: '',
            },
            params: props.match.params,
        }
    }

    componentDidMount() {

        getCity(city.value).then(({data}) => {

            let banners = [];
            if(data.categories.length > 0 && data.categories[0]['posts'].length > 0){
                banners = data.categories[0]['posts'];
            }

            this.setState({
                banners,
                details: data
            });
        });
    }

    render() {

        const {banners, details} = this.state;

        const {image} = details;

        let banner;
        if (image) {
            banner = APP.cities + '/image/' + image;
        }

        return (
            <React.Fragment>
                <MyHeader ImgBanner={banner} banners={banners} city={city} city_id={city.value} verticalAlign={'center'}>

                    {/*{*/}
                    {/*    city.value <= 2 && <div id="plane">*/}
                    {/*        <Image src={'/images/plane.png'} height={90}/>*/}
                    {/*    </div>*/}
                    {/*}*/}

                    <Responsive getWidth={getWidth} maxWidth={Responsive.onlyMobile.maxWidth}>
                        <div id="fav">
                            <div>
                                <Image
                                    src={"/images/icon-geral.png"}
                                    width={81}
                                    height={81}
                                    // style={{
                                    //     borderRadius: '50%'
                                    // }}
                                />
                            </div>
                            <div>
                                <h3>IN BH</h3>
                                <p><FormattedMessage id={"Deseja adicionar à sua tela inicial?"}/></p>
                                <Button.Group fluid>
                                    <Button
                                        basic
                                        content={<FormattedMessage id={"Fechar"}/>}
                                        onClick={() => {
                                            document.getElementById('fav').remove();

                                            let next = moment().add('1', 'hour').toJSON();

                                            localStorage.setItem('_HS', next);
                                        }}
                                    />
                                    <Button
                                        primary
                                        content={<FormattedMessage id={"Sim"}/>}
                                        id={'a2hs'}
                                    />
                                </Button.Group>
                            </div>
                        </div>
                    </Responsive>

                    {/*<Header as="h1" textAlign="center">*/}
                    {/*    <FormattedMessage*/}
                    {/*        id="welcome.city"*/}
                    {/*        defaultMessage={'Bem-vindo a {city}'}*/}
                    {/*        values={{*/}
                    {/*            city: city.text*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*</Header>*/}

                    {/*<Link to={'/espaco-horizonte/home/0/0'} style={{position:'absolute', bottom: 60}}>*/}
                    {/*    <Image src={'/images/espaco-horizonte-logo.jpg'} height={72}/>*/}
                    {/*</Link>*/}

                    {/*<Form>*/}
                    {/*    <Form.Group widths="equal">*/}
                    {/*        <Form.Input*/}
                    {/*            icon="search"*/}
                    {/*            iconPosition="left"*/}
                    {/*            placeholder="Encontrar Lugares ou Eventos"*/}
                    {/*        />*/}
                    {/*        <Form.Input*/}
                    {/*            icon="location arrow"*/}
                    {/*            iconPosition="left"*/}
                    {/*            placeholder="Localização"*/}
                    {/*        />*/}
                    {/*        <Form.Select placeholder="Categoria" options={cat}/>*/}
                    {/*        <Form.Button color="orange">PROCURAR</Form.Button>*/}
                    {/*    </Form.Group>*/}
                    {/*</Form>*/}

                </MyHeader>

                <Banner city_id={city.value} home={1} top={1} align={'center'}/>
                <Banner city_id={city.value} home={1} top={1} type={"S"} align={'center'}/>

                <Statistics city_id={city.value} subomain={subdomain}/>

                <Categories city_id={city.value} subdomain={subdomain}/>

                <Events city_id={city.value}/>

                <Posts city={city} city_id={city.value} from={'city'}/>

                <Posts city={city} city_id={city.value} from={'columnists'}/>

                {/*<Products/>*/}

                {(details && !isEmpty(details.know_title)) && <KnowCity details={details}/>}

                {/*<Testimony/>*/}

                {(details && !isEmpty(details.about_title)) && <App subdomain={subdomain} details={details}/>}

                <Banner city_id={city.value} home={1} bottom={1} align={'center'}/>
            </React.Fragment>
        );
    }
}

/*
const mapStateToProps = (state) => {
    return {
    categories: state.Categories
};
};

const mapDispatchToProps = dispatch => {
    return {
    fetchCategoriesFavorites: (city_id) => {
    return dispatch(fetchCategoriesFavorites(city_id));
}
};
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
*/

export default Home;

